module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h2', {
    staticClass: "Verse-head",
    attrs: {
      "id": "_idParaDest-10"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  }), _vm._v("Birth Pangs")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-long-new"
  }, [_vm._v("In the passionate eye of God")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-long"
  }, [_vm._v("(the raging stream of life)")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-long"
  }, [_vm._v("fruit ripens red, grey cities vermillion")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-long"
  }, [_vm._v("birth-pangs all, agony and celebration")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-long"
  }, [_vm._v("graffiti inscribed by lovers")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-long"
  }, [_vm._v("on the merging body of the groaning world")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-long"
  }, [_vm._v("ruby light arcing with the pain of severed life")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-long"
  }, [_vm._v("each wilderness a crucible of God")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-long"
  }, [_vm._v("and common place of all")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-long"
  }, [_vm._v("where gracious hands break moulds")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-long"
  }, [_vm._v("and form the violent love, the terror,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-long"
  }, [_vm._v("excesses of an ancient river flowing.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3722ea20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398400801_EPUB-12.vue
// module id = 93
// module chunks = 0